import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox } from '../../../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { useAccountFormContext } from '../../context/useAccountFormContext';

export const ExcludeFromDebtManagement = () => {
  const formBag = useFormContext();

  const {
    options: { ShowExcludeFromDebtManagementGoal: showExcludeFromDebtManagementGoal },
  } = useAccountFormContext();

  if (!showExcludeFromDebtManagementGoal) {
    return null;
  }

  return (
    <Checkbox {...formBag.register('bankAccount.ExcludeFromDebtManagementGoal')}>
      Exclude from debt management goal
    </Checkbox>
  );
};
